function positionClass(position) {
  switch (position) {
    case 'top-left':
      return 'left-2 top-2';
    case 'top-right':
      return 'right-2 top-2';
    case 'bottom-left':
      return 'left-2 bottom-2';
    case 'bottom-right':
      return 'right-2 bottom-2';
    default:
      return 'right-2 top-2';
  }
}

function refreshAllProductTileBadges() {
  document.querySelectorAll('.product-card[data-tags]').forEach((root) => {
    const stack = root._x_dataStack;
    const data = stack && stack[0];
    if (data && typeof data.InitProductBadges === 'function') {
      data.InitProductBadges();
    }
  });
}

function scheduleRefreshProductTileBadges() {
  requestAnimationFrame(() => refreshAllProductTileBadges());
}

if (typeof window !== 'undefined' && !window.__themeTileBadgesEditorBound) {
  window.__themeTileBadgesEditorBound = true;
  document.addEventListener('shopify:section:load', scheduleRefreshProductTileBadges);
  document.addEventListener('product-tags-badges:update', scheduleRefreshProductTileBadges);
}

window['ThemeTile'] = (link, title) => {
  return {
    hover: false,
    link: link,
    title: title,
    productTags: [],
    showLabel() {
      if (!this.$refs.tileLink) return;
      this.labelContent = this.$refs.labelContent.innerHTML;
      this.focusVisible = this.$refs.tileLink.matches(':focus-visible');
    },
    hideLabel() {
      this.labelContent = '';
      this.focusVisible = false;
    },
    async openQuickView() {
      this.$store.quickview.render(link);
      this.$store.modals.open('productQuickView');
    },
    init() {
      try {
        this.productTags = this.$el.dataset.tags ? JSON.parse(this.$el.dataset.tags) : [];
      } catch {
        this.productTags = [];
      }

      if (
        this.$refs.productBadges &&
        Object.keys(window).some((key) => key.startsWith('productTagsBadges'))
      ) {
        this.InitProductBadges();
      }
    },
    InitProductBadges() {
      if (!this.$refs.productBadges) return;

      const badgeKeys = Object.keys(window).filter((key) => key.startsWith('productTagsBadges'));
      const host = this.$refs.productBadges;
      host.replaceChildren();
      if (badgeKeys.length === 0) return;

      for (const key of badgeKeys) {
        const badgesConfig = window[key];
        if (!Array.isArray(badgesConfig)) continue;

        for (const badge of badgesConfig) {
          const tagList = String(badge.tags || '')
            .replaceAll(', ', ',')
            .split(',')
            .map((t) => t.trim())
            .filter(Boolean);
          if (!tagList.length) continue;
          if (!this.productTags.some((t) => tagList.includes(t))) continue;

          const span = document.createElement('span');
          span.style.backgroundColor = badge.badge_bg_color || '';
          span.style.color = badge.badge_text_color || '';
          span.className = `absolute z-10 ${positionClass(badge.badge_position)} pointer-events-none px-2.5 py-1`;
          span.textContent = badge.title != null ? String(badge.title) : '';
          host.appendChild(span);
        }
      }
    },
  };
};
